// Imports
// ------
import { observable } from 'mobx';

// Exports
export const loaderState = observable({
	isNeeded: true,
});
